import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'

if (document.getElementById('vue-news')) {
  new Vue({
    delimiters: ["[[", "]]"],
    el: '#vue-news',
    propsData: { ...document.getElementById('vue-news').dataset },
    props: {
      lang: {
        type: String,
        default: 'fr'
      }
    },
    data() {
      return {
        baseUrl: this.lang !== 'fr' ? `/${this.lang}/wp-json/wp/v2` : '/wp-json/wp/v2',
        searchQuery: '',
        isLoading: true,
        categories: [],
        filters: {
          page: 1,
          per_page: 6,
        },
        news: [],
        totalPages: null
      }
    },
    filters: {
        format(date) {
            return moment(date).locale('fr').format('DD/MM/YYYY')
        },
        truncate(text, length, suffix) {
            if (text.length > length) {
                return text.substring(0, length) + suffix;
            } else {
                return text;
            }
        }
    },
    created() {
      this.getNews()
    },
    computed: {
      hasMore() {
        return this.totalPages > this.news.length;
      },
    },
    methods: {
      deleteEmptyCategories(cat) {
        return cat.filter((el) => el.count != 0)
      },
      getCategories() {
        axios.request({
          method: 'GET',
          url: `${this.baseUrl}/categories`,
          params: {
            per_page: 50,
          }
        }).then(response => {
          this.categories = this.deleteEmptyCategories(response.data)
        })
      },
      getNews(more = false) {
        this.isLoading = true
        axios.request({
          method: 'GET',
          url: `${this.baseUrl}/posts`,
          data: this.form,
          headers: { 'content-type': 'application/json' },
          params: this.filters
        }).then(response => {
          const cleanNews = response.data.filter(el => el.catslug != "faq")
          this.news = (more)? this.news.concat(cleanNews) : cleanNews
          this.totalPages = response.headers['x-wp-total']
          this.isLoading = false
        }).catch((error) => {
          this.errors = Object.assign(this.errors, error.response.data)
        })
      },
      getMoreNews() {
        this.filters.page++;
        this.getNews(true);
      },
      updateSearch(e){
        this.filters.search = this.searchQuery
        this.getNews();
      },
    }
  })
}
